// AuthWrapper.jsx
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const VALID_LOGIN = 'admin';
const VALID_PASSWORD = 'secret';

function AuthWrapper({ children }) {
    const location = useLocation();
    const [authorized, setAuthorized] = useState(false);

    useEffect(() => {
        // Извлекаем параметры из строки запроса
        const params = new URLSearchParams(location.search);
        const login = params.get('login');
        const password = params.get('password');

        // Простейшая проверка, можно заменить на более надёжную
        if (login === VALID_LOGIN && password === VALID_PASSWORD) {
            setAuthorized(true);
        } else {
            setAuthorized(false);
        }
    }, [location]);

    if (!authorized) {
        return null;
        // (
        //     <div style={{ padding: '20px', opacity: 0 }}>
        //         <h3>Доступ к редактированию закрыт</h3>
        //         <p>
        //             Для доступа добавьте в адресную строку корректные параметры:
        //             <br />
        //             <code>?login=admin&password=secret</code>
        //         </p>
        //     </div>
        // );
    }

    return <>{children}</>;
}

export default AuthWrapper;
